<template>
    <!-- hero-wrap  -->
    <div class="hero-wrap fl-wrap full-height scroll-con-sec" id="sec0">
        <!--fs-slider-wrap -->						
        <div class="fs-slider-wrap fs-slider-det full-height fl-wrap">
            <div class="fs-slider lightgallery full-height fl-wrap" data-mousecontrol2="false">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide hov_zoom" v-for="slide in slides" :key="slide.id">
                            <div class="fs-slider-item fl-wrap">
                                <div class="fs-slider_align_title">
                                    <div class="hhw_header"></div>
                                    <h2>
                                        <a href="#">{{ slide.title }} <br> <span>{{ slide.subtitle }}</span></a>
                                    </h2>
                                    <p>{{ slide.content }}</p>
                                    <div class="clearfix"></div>
                                    <a href="#sec1" class="hero_btn custom-scroll-link">Explore More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- hero-slider-img-->
            <div class="hero-slider-img hidden-item">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- Dynamic slide backgrounds -->
                        <div class="swiper-slide" v-for="slide in slides" :key="'bg-' + slide.id">
                            <div class="bg" :data-bg="slide.image" data-swiper-parallax="20%"></div>
                            <div class="overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- hero-slider-img  end-->							
        </div>
        <!--fs-slider-wrap end -->				
        <!-- hero-slider_details_wrap--> 
        <div class="hero-dec"></div>
        <div class="fwc-dec fwc-dec_top"></div>
        <div class="fwc-dec fwc-dec_right"></div>
        <div class="clone-counter">
            <div class="current">01</div>
        </div>
        <div class="hero-slider_details_wrap">
            <div class="slide-progress-wrap">
                <div class="slide-progress"></div>
            </div>
            <div class="swiper-counter hs_counter">
                <div class="current">01</div>
                <div id="total"></div>
            </div>
            <div class="play-pause_slider2 hsc_pp2 auto_actslider2">
                <i class="fas fa-play"></i>
            </div>
        </div>
        <!-- hero-slider_details_wrap  end -->					
        <div class="hero-slider-wrap_pagination"></div>
        <div class="hero-slider_control-wrap">
            <div class="hsc hero-slider-button-prev">
                <span><i class="fal fa-angle-left"></i></span>
            </div>
            <div class="hsc hero-slider-button-next">
                <span><i class="fal fa-angle-right"></i></span>
            </div>
        </div>
        <div class="hero-dec-line"></div>
        <a href="#sec1" class="custom-scroll-link start-btn">
            <span>Start explore</span><i class="fal fa-long-arrow-down"></i>
        </a>						
    </div>
    <!-- hero-wrap  end-->
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'HeroSlider',
    data() {
        return {
            siteName: '',
            siteDescription: '',
            slides: [],
            textSwiper: null,
            imageSwiper: null
        }
    },
    created() {
        // Load site name and description from store
        const siteDefaultsStore = useSiteDefaultsStore()
        this.siteName = siteDefaultsStore.getSiteName() || 'Upatto'
        this.siteDescription = siteDefaultsStore.getSiteDescription() || this.siteDescription
    },
    async mounted() {
        // First load slides from API
        await this.loadSlides()
        
        // Then initialize Swiper after slides are loaded and rendered
        this.$nextTick(() => {
            setTimeout(() => {
                this.initSwiper()
                // Theme initialization is handled globally by router
            }, 100)
        })
    },
    beforeUnmount() {
        console.log('🧹 Cleaning up HeroSlider...')
        const $ = window.jQuery
        
        // Clean up Swiper instances
        if (this.textSwiper) {
            try {
                this.textSwiper.destroy(true, true)
                console.log('✅ Text Swiper destroyed')
            } catch (e) {
                console.warn('⚠️ Error destroying text swiper:', e)
            }
            this.textSwiper = null
        }
        if (this.imageSwiper) {
            try {
                this.imageSwiper.destroy(true, true)
                console.log('✅ Image Swiper destroyed')
            } catch (e) {
                console.warn('⚠️ Error destroying image swiper:', e)
            }
            this.imageSwiper = null
        }
        
        // Clean up resize event listener
        if ($) {
            $(window).off('resize.heroSlider')
        }
        
        console.log('✅ HeroSlider cleanup complete')
    },
    methods: {
        async loadSlides() {
            try {
                const response = await this.$api.get('public/sliders')
                if (response.data && response.data.status === 'success') {
                    // API returns data in the exact format we need:
                    // { id, title, subtitle, content, image, layer_1, layer_2, layer_3 }
                    this.slides = response.data.data || []
                    console.log('✅ Loaded', this.slides.length, 'slider(s)')
                }
            } catch (error) {
                console.error('❌ Failed to load hero slides:', error)
                this.slides = []
            }
        },
        initSwiper() {
            // Don't initialize if already initialized or no slides
            if (this.textSwiper || this.slides.length === 0) return

            console.log('🎬 Initializing Swiper with', this.slides.length, 'slides')

            const $ = window.jQuery
            const Swiper = window.Swiper

            if (!$ || !Swiper) {
                console.error('❌ jQuery or Swiper not loaded')
                return
            }

            // CRITICAL: Process data-bg attributes BEFORE Swiper initializes
            // This ensures background images are loaded when Swiper calculates dimensions
            console.log('🖼️ Processing background images...')
            $('.hero-slider-img .swiper-slide .bg[data-bg]').each(function() {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                    console.log('  ✅ Set background:', bg)
                }
            })

            // Set CSS heights for slider elements (from original theme's csselem function)
            $(".fs-slider-item").css({
                height: $(".fs-slider").outerHeight(true)
            })
            $(".hero-slider-img .swiper-slide").css({
                height: $(".hero-slider-img").outerHeight(true)
            })

            // Force a reflow to ensure CSS is applied
            void document.querySelector('.hero-slider-img').offsetHeight

            // Get mousewheel control setting
            const mouseContr2 = $(".fs-slider").data("mousecontrol2")

            // Initialize text/content slider
            this.textSwiper = new Swiper(".fs-slider .swiper-container", {
                preloadImages: false,
                loop: true,
                grabCursor: true,
                speed: 2000,
                spaceBetween: 0,
                effect: "slide",
                mousewheel: mouseContr2,
                pagination: {
                    el: '.hero-slider-wrap_pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.hero-slider-button-next',
                    prevEl: '.hero-slider-button-prev',
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                }
            })

            // Initialize image slider
            this.imageSwiper = new Swiper(".hero-slider-img .swiper-container", {
                preloadImages: false,
                loop: true,
                resistance: true,
                parallax: true,
                effect: "slide",
            })

            // Link the two swipers together
            this.textSwiper.controller.control = this.imageSwiper
            this.imageSwiper.controller.control = this.textSwiper

            // Update counter on slide change
            this.textSwiper.on('slideChange', () => {
                const csli = this.textSwiper.realIndex + 1
                const curnum = $('.current')
                
                if (window.TweenMax) {
                    window.TweenMax.to(curnum, 0.2, {
                        force3D: true,
                        y: -10,
                        opacity: 0,
                        ease: window.Power2.easeOut,
                        onComplete: function () {
                            window.TweenMax.to(curnum, 0.1, {
                                force3D: true,
                                y: 10
                            })
                            curnum.html("0" + csli)
                        }
                    })
                    window.TweenMax.to(curnum, 0.2, {
                        force3D: true,
                        y: 0,
                        delay: 0.3,
                        opacity: 1,
                        ease: window.Power2.easeOut
                    })
                } else {
                    curnum.html("0" + csli)
                }
            })

            // Set total slides count
            const totalSlides = this.slides.length
            $('#total').html("0" + totalSlides)

            // Autoplay control buttons
            const autobtn2 = $(".play-pause_slider2")
            const autoEnd2 = () => {
                autobtn2.removeClass("auto_actslider2")
                this.textSwiper.autoplay.stop()
            }
            const autoStart2 = () => {
                autobtn2.addClass("auto_actslider2")
                this.textSwiper.autoplay.start()
            }
            autobtn2.on("click", () => {
                if (autobtn2.hasClass("auto_actslider2")) autoEnd2()
                else autoStart2()
                return false
            })

            // Slide transition effects
            this.textSwiper.on("slideChangeTransitionStart", () => {
                $(".slide-progress").css({
                    width: 0,
                    transition: "width 0s"
                })
            })
            this.textSwiper.on("slideChangeTransitionEnd", () => {
                $(".slide-progress").css({
                    width: "100%",
                    transition: "width 3000ms"
                })
            })

            // Force Swiper to recalculate dimensions after a brief delay
            // to ensure background images have started loading
            setTimeout(() => {
                if (this.textSwiper) this.textSwiper.update()
                if (this.imageSwiper) this.imageSwiper.update()
                console.log('🔄 Swiper dimensions updated')
            }, 200)

            // Add window resize handler to recalculate heights
            $(window).on('resize.heroSlider', () => {
                $(".fs-slider-item").css({
                    height: $(".fs-slider").outerHeight(true)
                })
                $(".hero-slider-img .swiper-slide").css({
                    height: $(".hero-slider-img").outerHeight(true)
                })
                if (this.textSwiper) this.textSwiper.update()
                if (this.imageSwiper) this.imageSwiper.update()
            })

            console.log('✅ Swiper initialized successfully')
        }
    }
}
</script>

